import { render, staticRenderFns } from "./CurrentInfoCard.vue?vue&type=template&id=3fcf33b4&scoped=true&"
import script from "./CurrentInfoCard.vue?vue&type=script&lang=js&"
export * from "./CurrentInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./CurrentInfoCard.vue?vue&type=style&index=0&id=3fcf33b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcf33b4",
  null
  
)

export default component.exports